module.exports = function() {
  return new Worker(__webpack_public_path__ + "7489294a7287719df746.worker.js");
};